import ResignationList from "./ResignationList";

export default function ResignationTab({ setTrigger, trigger }) {
  return (
    <div className="p-2">
      <ResignationList
        setTrigger={setTrigger}
        trigger={trigger}
      />
    </div>
  );
}
